import styled from 'styled-components'

import { ButtonAddUnstyled } from 'Components/Buttons/ButtonAdd/unstyled'

export const ButtonAdd = styled(ButtonAddUnstyled)`
  display: block;
  background: ${props => props.theme.colors.primary};
  cursor: pointer;
  border-radius: 6px;
  border: none;
  margin: 0;
  padding: 0;
  transitions: background-color, 0.3s;
  &:hover {
    background-color: #fd3758;
  }
  &:focus {
    background-color: #d72b4f;
  }
  &:disabled {
    background-color: #aeafc7;
  }
  svg {
    width: ${props => (props.size === 'small' ? '24px' : '40px')};
    height: ${props => (props.size === 'small' ? '24px' : '40px')};
    display: block;
    padding: ${props => (props.size === 'small' ? '5px' : '10px')};
    &.fill-white {
      fill: ${props => props.theme.colors.white};
    }
    path {
      stroke: ${props => props.theme.colors.white};
    }
  }
`
